import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import DocumentView from 'components/sales/downloadDocView/documentView';

const ViewSiteInspectionChecklist = ({
  match,
  getSiteInfoChecklist,
  siteInspectionChecklist
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [rejectMod, setRejectModal] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [modal, setModal] = useState(false);


  useEffect(() => {
    (async () => {
      if (getSiteInfoChecklist) {
        setIsLoading(true);
        if (match.params.stageId == 5) {
          await getSiteInfoChecklist(match.params.id, match.params.stageId);
        } else {
          await getSiteInfoChecklist(match.params.id, match.params.stageId, match.params.gateId);
        }
        setIsLoading(false);
      }
    })();
  }, [getSiteInfoChecklist]);

  useEffect(() => {
    (() => {
      if (
        poclist &&
        poclist.length > 0 &&
        poclist.some((obj) => obj.id === 'Others')
      ) {
        setShowOtherEmail(true);
      } else {
        setShowOtherEmail(false);
      }
    })();
  }, [poclist]);

  useEffect(() => {
    const list =
      poclist && poclist.length > 0 && poclist.map((element) => element['id']);
    setMailList(list);
  }, [poclist]);


  return (
    <Layout
      title={siteInspectionChecklist?.checklist_name}
    //   Buttons={headerBtns}
      isLoading={isLoading}
      isGoback
      linkUrl={`${baseUrl}/approvals/pm-sites`}
    >
      {siteInspectionChecklist &&
      <div className="panel-card" key={1}>
        <div className="panel-heading">{siteInspectionChecklist?.gate_name}</div>
          <div className="panel-body">
            <div className="form-group">
              <div className="details-listing faq-listing">
                {siteInspectionChecklist &&
                  siteInspectionChecklist.questions &&
                  siteInspectionChecklist.questions.length &&
                  siteInspectionChecklist.questions.map((obj, index) => {
                    return (
                        <div
                          className="details-list question-input"
                          key={index}
                        >
                              <label className="data-title">{obj.questions}</label>
                               {(
                                    obj.type.toLowerCase() === 'file' ||
                                    obj.type_id === 4
                                  ) ?
                                    <>
                                      <div className="row">
                                        <div className="">
                                          <div className="col-md-12">
                                            <img
                                                src={obj.answer}
                                                width="100%"
                                                key={1}
                                              />
                                            <br></br>
                                            <br></br>
                                          </div>
                                        </div>  
                                      </div>
                                              
                                    </>
                                    :
                                    <>
                                      <div className="sub-question">
                                        <label className="label">{obj.label}</label>
                                        <label className="label">
                                          {obj.answer}
                                        </label>
                                      </div>
                                    </>
                                  }                      
                            </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      }
    </Layout>
  );
};

export default ViewSiteInspectionChecklist;
